'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../../language/translate');

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */
exports.default = function (values, props) {
  return {
    applicant: values.applicant.map(function (applicant, i) {
      return {
        dob: !applicant.dob,
        first_name: !applicant.first_name,
        last_name: !applicant.last_name,
        email: i === 0 && !(0, _commonFunctions.isEmailValid)(applicant.email),
        additional_data: {
          mq: {
            mq1: !applicant.additional_data.mq.mq1 || applicant.additional_data.mq.mq1 === 'Yes',
            mq2: !applicant.additional_data.mq.mq2 || applicant.additional_data.mq.mq2 === 'Yes',
            mq3: !applicant.additional_data.mq.mq3 || applicant.additional_data.mq.mq3 === 'Yes',
            mq4: !applicant.additional_data.mq.mq4 || applicant.additional_data.mq.mq4 === 'Yes',
            mq5: !applicant.additional_data.mq.mq5 || applicant.additional_data.mq.mq5 === 'Yes',
            mq6: !applicant.additional_data.mq.mq6 || applicant.additional_data.mq.mq6 === 'Yes',
            mq7: !applicant.additional_data.mq.mq7 || applicant.additional_data.mq.mq7 === 'Yes',
            mq8: !applicant.additional_data.mq.mq8
          }
        }
      };
    }),
    application: {
      effective_date: !values.application.effective_date,
      // expiry_date: !values.application.expiry_date,
      additional_data: {
        eligibility: !values.application.additional_data.eligibility,
        policy_type: !values.application.additional_data.policy_type,
        billing_date: values.payment.payment_option === 'monthly' && !values.application.additional_data.billing_date
      }
    },
    payment: {
      payment_option: !values.payment.payment_option
    },
    errors: props.application.quote.information && Array.isArray(props.application.quote.information)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/rimisecureadvantageplus/Quote.js
// module id = 1781
// module chunks = 0